import { render, staticRenderFns } from "./curriculum.vue?vue&type=template&id=8dd4e45e&scoped=true&"
import script from "./curriculum.vue?vue&type=script&lang=js&"
export * from "./curriculum.vue?vue&type=script&lang=js&"
import style0 from "./curriculum.vue?vue&type=style&index=0&id=8dd4e45e&prod&lang=css&"
import style1 from "./curriculum.vue?vue&type=style&index=1&id=8dd4e45e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd4e45e",
  null
  
)

export default component.exports